import { render } from "./ProductTypeData.vue?vue&type=template&id=3919e476"
import script from "./ProductTypeData.vue?vue&type=script&lang=js"
export * from "./ProductTypeData.vue?vue&type=script&lang=js"

import "./ProductTypeData.vue?vue&type=style&index=0&id=3919e476&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__